export const APP_STORE_URL = "https://apps.apple.com/my/app/etikaf/id1315018599";
export const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.etikaf.app";
